import React, { useContext, useMemo } from 'react';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { isGreater } from '@/pages/dashboard/pages/overview/_config/common';
import './index.scss';

export default function KeyMetrics(props: any) {
  const { children, data, ...restProps } = props || {};
  const { mainMetricsList = [], height = 460, isChangeHeight = 424, loadingHeight } = data || {};
  const contextObj = useContext(FilterContext);
  const { filterVal } = contextObj || {};
  const dateDimension = filterVal?.timeType?.toUpperCase() || 'DAY';
  const isChange = isGreater(dateDimension, filterVal?.rangeTime || []);
  const { data: keyMetricsData, loading, errorMsg } = data?.keyMetricsData || {};
  const { card_list: metricsData = [], trend_list: keyMetricsTrend = [] } = keyMetricsData || {};

  const { trendData, xAxisData } = useMemo(() => {
    const trendData: any = {};
    const xAxisData = keyMetricsTrend?.map((item: any) => item?.date);
    if (keyMetricsTrend) {
      mainMetricsList?.map((v: any) => {
        const currentList: string[] = [];
        const lastList: string[] = [];
        keyMetricsTrend?.map((item: any) => {
          currentList?.push(item?.metrics?.[v]?.value);
          lastList?.push(item?.metrics?.[v]?.last_value);
        });
        trendData[v] = [currentList, lastList];
      });
    }
    return {
      xAxisData,
      trendData,
    };
  }, [keyMetricsTrend, mainMetricsList]);

  const componentItem = (
    // 保证是jsx数组，而不是其他类型数组
    React.Children.map(children, (child: any) => React.cloneElement(
      child,
      {
        ...restProps,
        dateDimension,
        isChange,
        metricsData,
        trendData,
        xAxisData,
        keyMetricsTrend,
        data,
        state: {}
      }
    ))
  );

  return (
    <Abnormal
      isLoading={loading}
      isError={errorMsg}
      style={{ background: '#fff', marginTop: '20px', marginBottom: '20px', height: loadingHeight ? loadingHeight: isChange ? isChangeHeight : height }}
      component={componentItem}
    />
  );
};
